document.addEventListener('DOMContentLoaded', function() {
  (function($){
    function enableQtyActions(variant_id) {
      $('.product__current-count-increase[data-id="'+ variant_id +'"]').removeClass('disabled');
      $('.product__current-count-decrease[data-id="'+ variant_id +'"]').removeClass('disabled');
      $('.product__current-count[data-id="'+ variant_id +'"]').removeClass('quickadd-loading');
    }

    function disableQtyActions(variant_id) {
      $('.product__current-count-increase[data-id="'+ variant_id +'"]').addClass('disabled');
      $('.product__current-count-decrease[data-id="'+ variant_id +'"]').addClass('disabled');
      $('.product__current-count-amount[data-id="'+ variant_id +'"]').html('');
      $('.product__current-count[data-id="'+ variant_id +'"]').addClass('quickadd-loading');
    }

    function updateQtyActions(variant_id, newQty) {
      if ( newQty === '0' ) {
        $('.product__current-count[data-id="'+ variant_id +'"]').removeClass('quickadd-loading').removeClass('has-qty');
        $('.product__quickadd[data-id="'+ variant_id +'"] span').text('Add to Cart').removeClass('quickadd-loading');
        $('.product__quickadd[data-id="'+ variant_id +'"]').removeClass('hidden');
      } else {
        $('.product__quickadd[data-id="'+ variant_id +'"]').addClass('hidden');
        $('.product__current-count[data-id="'+ variant_id +'"]').addClass('has-qty');

        $('.product__current-count-increase[data-id="'+ variant_id +'"]').data('quantity', newQty + 1);
        $('.product__current-count-decrease[data-id="'+ variant_id +'"]').data('quantity', newQty - 1);
        $('.product__current-count-amount[data-id="'+ variant_id +'"]').html('<span class="current-item-cart-qty">' + newQty + '</span> <span class="in-cart">in cart</span>');
      }
    }

    function updateLoopUI(cart) {
      if ( cart.items.length ) {
        cart.items.forEach( function(item) {
          updateQtyActions(item.variant_id, item.quantity);
          enableQtyActions(item.variant_id);
        });
      }
    }

    $(document).on('click', '.product__current-count-increase, .product__current-count-decrease', function(){
      var _this = $(this),
        id = _this.data('id').toString(),
        qty = _this.data('quantity').toString();

      disableQtyActions($(this).data('id'));
      MiniCart.updateItemQuantity(id, qty).then(function(cart){
        updateLoopUI(cart);
        if ( qty === '0' ) {
          updateQtyActions(id, qty);
          enableQtyActions(id);
        }
      });
    });

    if ( $('body').hasClass('collection-template') ) {
      document.addEventListener('cartItemAdded.miniCart', function(e) {
        updateLoopUI(e.detail);
      });

      document.addEventListener('cartItemQuantityUpdated.miniCart', function(e) {
        updateLoopUI(e.detail);
      });
    }

    // HIDE apple chat on mobile
    var apple_chat_orig_styles = '';
    
    document.addEventListener('cartOpened.miniCart', function (e) {
      var target = $('#AppleBusinessChat');
      
      apple_chat_orig_styles = target.attr('style');
      
      // only hide for small screens
      if ($(window).width() < 960 ) {
        target.attr('style', 'display:none !important!;');
      }
    });

    document.addEventListener('cartClosed.miniCart', function (e) {
      $('#AppleBusinessChat').attr('style', apple_chat_orig_styles);
    });

  })(jQuery);
});
